// Mock data utilities and central export

export const mockDelay = (ms: number = 500): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};

// Re-export all mock data
export * from './gpu-instance';
export * from './serverless-gpu';
